








import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class NewsTicker extends Vue {
    constructor() {
        super();
    }
}
